import { Box } from '@mui/material';
import { navigate } from '../lib/navigation';

function LogoMark() {
  return (
    <Box
      component="img"
      src="/creatorcv_logo.png"
      alt="CreatorCV"
      onClick={() => navigate('/')}
      role="button"
      aria-label="CreatorCV home"
      sx={{ height: 40, width: 'auto', alignSelf: 'flex-start', cursor: 'pointer' }}
    />
  );
}

export default LogoMark;
